import { render, staticRenderFns } from "./TicketCommissions.vue?vue&type=template&id=5cd16f9e&"
import script from "./TicketCommissions.vue?vue&type=script&lang=js&"
export * from "./TicketCommissions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports